import script from "./VideoViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoViewer.vue?vue&type=script&setup=true&lang=js"

import "./VideoViewer.vue?vue&type=style&index=0&id=aac2b706&lang=less&scoped=true"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aac2b706"]])

export default __exports__